import { render, staticRenderFns } from "./owner.vue?vue&type=template&id=6f51a5e5&scoped=true&"
import script from "./owner.vue?vue&type=script&lang=js&"
export * from "./owner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f51a5e5",
  null
  
)

export default component.exports